






























































































































































































import { Component, Emit, Prop, PropSync } from 'nuxt-property-decorator'
import {
  Col,
  DataTable,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'

import { orderBy } from 'lodash'
import { ReserveType, SortOrder, UserDetailTabType } from '@/types'
import {
  BibliographyRealDetailReserve,
  ReserveSpecifyBranchCode,
  SystemCode
} from '@/api'
import RecycleScroller from '@/components/molecules/RecycleScroller/RecycleScroller.vue'
import { dataStore } from '@/utils/store-accessor'

@Component({
  components: { RecycleScroller, DataTable }
})
export default class CollectionReserveStatusTable extends DataTable {
  @Prop({
    type: Array,
    required: true
  })
  items!: BibliographyRealDetailReserve[]

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  @Prop({
    type: Boolean,
    default: false
  })
  specifyCollectionIdLink!: boolean

  @PropSync('selected', {
    type: Object,
    required: true
  })
  selectedItem!: BibliographyRealDetailReserve

  sortName: string = ''

  sortOrder: SortOrder = ''

  get reserveType(): any {
    return ReserveType
  }

  get displayReserveUserName(): boolean {
    return dataStore.displayBibliographyDetailPageReserveUserName
  }

  get showCols(): Col[] {
    return [
      {
        width: 26,
        items: [
          {
            name: 'radio',
            align: 'center'
          }
        ]
      },
      {
        width: 50,
        items: [
          {
            name: 'no',
            align: 'right'
          }
        ]
      },
      {
        width: '11',
        resizable: true,
        items: [
          {
            name: 'reserveUser',
            headerText:
              '予約者' + (this.displayReserveUserName ? '氏名' : '番号'),
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '9',
        resizable: true,
        items: [
          {
            name: 'reserveRegistrationTime',
            headerText: '予約日',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '9',
        resizable: true,
        items: [
          {
            name: 'preferredDate',
            headerText: '受取希望日',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '9',
        resizable: true,
        items: [
          {
            name: 'reserveExpiration',
            headerText: '有効期限日',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '7',
        resizable: true,
        items: [
          {
            name: 'specifyBranchCodes',
            headerText: '特定館',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '7',
        resizable: true,
        items: [
          {
            name: 'reserveRegistrationBranchCode',
            headerText: '予約館',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '7',
        resizable: true,
        items: [
          {
            name: 'forwardingBranchCode',
            headerText: '回送館',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '6',
        resizable: true,
        items: [
          {
            name: 'specifyCollectionId',
            headerText: '種別',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '7',
        resizable: true,
        items: [
          {
            name: 'reserveStatus',
            headerText: '状態',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '6',
        resizable: true,
        items: [
          {
            name: 'reserveNoticeAllowed',
            headerText: '通知',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '13',
        resizable: true,
        items: [
          {
            name: 'displayMemo',
            headerText: 'メモ',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        items: [
          {
            name: 'contactMethod',
            headerText: '連絡方法',
            sortable: true,
            sortOrder: ''
          }
        ]
      }
    ]
  }

  get sortedItems(): BibliographyRealDetailReserve[] {
    if (this.sortName) {
      return orderBy<BibliographyRealDetailReserve>(
        this.items,
        (item: BibliographyRealDetailReserve) => {
          const propertyValue =
            item[this.sortName as keyof BibliographyRealDetailReserve]
          const type: string = Object.prototype.toString
            .call(propertyValue)
            .slice(8, -1)
            .toLowerCase()

          if (type === 'object') return (propertyValue as SystemCode).shortName
          if (this.sortName === 'specifyBranchCodes') {
            return this.joinSpecifyBranchCodes(
              propertyValue as ReserveSpecifyBranchCode[]
            )
          }

          return propertyValue
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.items
  }

  joinSpecifyBranchCodes(array: ReserveSpecifyBranchCode[]): string {
    return array.map(array => array.branchCode.shortName).join(' ')
  }

  onClickTableRow(index: number): void {
    if (this.selectedItem === this.sortedItems[index]) {
      return
    }

    this.selectedItem = this.sortedItems[index]
    this.$emit('selected')
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }

  openModalUserDetail(userId: string): void {
    this.$modalUserDetail.open({
      userId,
      initialActiveTab: UserDetailTabType.Reserved
    })
  }

  @Emit('specify-collection-id')
  onClickSpecifyCollectionIdLink(
    reserveType: ReserveType,
    reserveSetGroupId: number,
    userId: string
  ): any {
    return {
      reserveType,
      reserveSetGroupId,
      userId
    }
  }
}
